/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

async function handleAccountPageAddToCart(event, productId) {
  try {
    const button = event.target;
    const tr = button.closest("tr");
    const quantityInput = tr.querySelector(".quantity-selector");
    const cartCount = document.querySelector("#CartCount");

    button.disabled = true;
    button.textContent = "Adding...";

    const productVariantId = productId.split("/").pop();
    const quantity = parseInt(quantityInput?.value || 1);

    const addResponse = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: productVariantId,
        quantity: quantity,
        properties: {
          _source: "Rebuy",
        },
      }),
    });


    if (!addResponse.ok) {
      throw new Error("Failed to add item to cart");
    }

    const cartResponse = await fetch("/cart.js");
    if (!cartResponse.ok) {
      throw new Error("Failed to get cart");
    }
    const cart = await cartResponse.json();

    cartCount.textContent = cart.item_count;
    button.disabled = false;
    button.textContent = "Add to Cart";
  } catch (error) {
    console.error("Error adding item to cart:", error);
  }
}

async function handleCollectionPageAddToCart(event, productId) {
  try {
    event.preventDefault();
    const Cart = window.Rebuy.Cart;
    Cart.addItem({
      items: [
        {
          id: productId,
          quantity: 1,
          properties: {
            _source: "Rebuy",
          },
        },
      ],
    });

  } catch (error) {
    console.error("Error adding item to cart:", error);
  }
}

